import React, { useEffect, useState } from 'react'
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'
import FormControlLabel from '@mui/material/FormControlLabel'
import Radio from '@mui/material/Radio'
import RadioGroup from '@mui/material/RadioGroup'
import Box from '@mui/material/Box'
import FormControl from '@mui/material/FormControl'
import FormLabel from '@mui/material/FormLabel'
import Slide from '@mui/material/Slide'
import { useHistory, useParams } from 'react-router-dom'
import ArrowLeftIcon from '@mui/icons-material/ArrowLeft'
import ArrowRightIcon from '@mui/icons-material/ArrowRight'
import Button from '@mui/material/Button'
import HighlightOffIcon from '@mui/icons-material/HighlightOff'
import CheckIcon from '@mui/icons-material/Check'
import { toast } from 'react-toastify'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import CardMedia from '@mui/material/CardMedia'
import YellowSwitch from '../../common/YellowSwitch'
import DashboardLayout from '../layouts/DashboardLayout'
import ColorButton from '../../common/ColorButton'
import getFirestoreDocById from '../../common/getFirestoreDocById'
import { UrlParams } from '../../types'
import { doc, updateDoc, db } from '../../config/firebaseConfig'
import useAuth from '../../hooks/useAuth'
import color1ConsoleLog from '../../common/color1ConsoleLog'
import FullPageLoader from '../../common/FullPageLoader'

const ReviseStep11 = () => {
  console.log('ReviseStep11')

  const { user } = useAuth()
  console.log('%cuser : %s', color1ConsoleLog, user?.uid)

  const { id, area } = useParams<UrlParams>()
  console.log('%cThe id is : %s', color1ConsoleLog, id)
  console.log('%cThe area is : %s', color1ConsoleLog, area)

  const history = useHistory()

  const goToReviseStep10 = () => {
    history.push(`/revision/${area}/10/${id}`)
  }

  const goToReviseStep12 = () => {
    history.push(`/revision/${area}/12/${id}`)
  }

  const [formData, setFormData]: any = useState()
  const [loading, setLoading] = useState(true)
  const [isAllowed, setIsAllowed] = useState(false)
  const [key, setKey] = useState('')
  // eslint-disable-next-line
  const [areaUrlParam, setAreaUrlParam] = useState('')
  const [approvedAt, setApprovedAt] = useState('')

  useEffect(() => {
    (async () => {
      if (id) {
        const res = await getFirestoreDocById(id)
        if (res) {
          setFormData(res)
          if (area === 'tsu') {
            console.log('res?.p16workSupervisor', res?.p16workSupervisor)
            console.log('%cp16workSupervisor has id', color1ConsoleLog)
            setIsAllowed(true)
            setKey('p16workSupervisorApproved11')
            setAreaUrlParam('tsu')
            setApprovedAt('p16workSupervisorApprovedAt11')
          }
          if (area === 'pep') {
            console.log('%cp16pepCoordinator has id', color1ConsoleLog)
            setIsAllowed(true)
            setKey('p16pepCoordinatorApproved11')
            setAreaUrlParam('pep')
            setApprovedAt('p16pepCoordinatorApprovedAt11')
          }
          if (area === 'aco') {
            console.log('%cp16areaCoordinator has id', color1ConsoleLog)
            setIsAllowed(true)
            setKey('p16areaCoordinatorApproved11')
            setAreaUrlParam('aco')
            setApprovedAt('p16areaCoordinatorApprovedAt11')
          }
          if (area === 'qt') {
            console.log('%cp16quality has id', color1ConsoleLog)
            setIsAllowed(true)
            setKey('p16qualityApproved11')
            setAreaUrlParam('qt')
            setApprovedAt('p16qualityApprovedAt11')
          }
          if (area === 'ta') {
            console.log('%cp16technicalArea has id', color1ConsoleLog)
            setIsAllowed(true)
            setKey('p16technicalAreaApproved11')
            setAreaUrlParam('ta')
            setApprovedAt('p16technicalAreaApprovedAt11')
          }
          if (area === 'ps') {
            console.log('%cp16patrimonialSecurity has id', color1ConsoleLog)
            setIsAllowed(true)
            setKey('p16patrimonialSecurityApproved11')
            setAreaUrlParam('ps')
            setApprovedAt('p16patrimonialSecurityApprovedAt11')
          }
          if (area === 'ep') {
            console.log('%cp16externalPrevencionist has id', color1ConsoleLog)
            setIsAllowed(true)
            setKey('p16externalPrevencionistApproved11')
            setAreaUrlParam('ep')
            setApprovedAt('p16externalPrevencionistApprovedAt11')
          }
          if (area === 'sass') {
            console.log('%cp16sass has id', color1ConsoleLog)
            setIsAllowed(true)
            setKey('p16sassApproved11')
            setAreaUrlParam('sass')
            setApprovedAt('p16sassApprovedAt11')
          }
          setLoading(false)
        } else {
          setLoading(false)
        }
      }
    })()
  }, [])

  if (loading) {
    <Typography>Cargando</Typography>
  }
  console.log('formData step 11', formData)

  const approve = async (e: any) => {
    e.preventDefault()
    const approveformRef = doc(db, 'forms', id)
    const obj: any = {}
    obj[key] = true
    obj[approvedAt] = new Date()
    try {
      await updateDoc(approveformRef, obj)
      console.log('approved', key, approvedAt)
      toast.success('La aprobación se actualizó correctamente')
    } catch (updateError) {
      toast.error(`Error: ${updateError}`)
    }
  }

  const disapprove = async (e: any) => {
    e.preventDefault()
    const approveformRef = doc(db, 'forms', id)
    const obj: any = {}
    obj[key] = false
    obj[approvedAt] = new Date()
    try {
      await updateDoc(approveformRef, obj)
      console.log('disapproved', key, approvedAt)
      toast.success('La desaprobación se actualizó correctamente')
    } catch (updateError) {
      toast.error(`Error: ${updateError}`)
    }
  }

  return (
    <DashboardLayout>
      {loading ? <FullPageLoader /> : (
        <Slide direction="right" in mountOnEnter unmountOnExit>
          <Grid sx={{ mt: 4 }} container justifyContent="center" spacing={2}>
            <Grid item xs={10} sm={9} md={5} lg={7}>
              {
                (formData?.p16workSupervisor === user?.uid)
                  || (formData?.p16pepCoordinator === user?.uid)
                  || (formData?.p16areaCoordinator === user?.uid)
                  || (formData?.p16quality === user?.uid)
                  || (formData?.p16technicalArea === user?.uid)
                  || (formData?.p16patrimonialSecurity === user?.uid)
                  || (formData?.p16externalPrevencionist === user?.uid)
                  || (formData?.p16sass === user?.uid)
                  || (formData?.p16sassAllowedList?.includes(user?.uid))
                  ? (
                    <>
                      <Typography
                        sx={{ mb: 2 }}
                        align="center"
                        variant="h6"
                        color="text.secondary"
                        gutterBottom
                      >
                        MANTENIMIENTO Y SS.GG.
                      </Typography>

                      <Grid display="flex" justifyContent="center" item xs={12}>
                        <FormControlLabel
                          control={(
                            <YellowSwitch
                              checked={formData?.p11show}
                              inputProps={{ 'aria-label': 'controlled' }}
                            />
                          )}
                          label={formData?.p11show ? 'Esta página aplica' : 'Esta página no aplica'}
                        />
                      </Grid>

                      <Box
                        component="div"
                        sx={{
                          display: formData?.p11show ? 'block' : 'none',
                        }}
                      >
                        <Box sx={{
                          display: 'flex', justifyContent: 'center', mt: 4, mb: 2,
                        }}
                        >
                          <FormControl sx={{ display: 'flex', mb: 2 }} component="fieldset">
                            <FormLabel component="legend">Mascarilla</FormLabel>
                            <RadioGroup
                              sx={{ flex: '1', flexDirection: 'row' }}
                              aria-label="atrapamiento"
                              name="atrapamiento"
                              value={formData?.p11mask}
                            >
                              <FormControlLabel value="SI" control={<Radio checked={formData?.p11mask === 'SI'} />} label="SI" />
                              <FormControlLabel value="NO" control={<Radio checked={formData?.p11mask === 'NO'} />} label="NO" />
                              <FormControlLabel value="NA" control={<Radio checked={formData?.p11mask === 'NA'} />} label="N/A" />
                            </RadioGroup>
                          </FormControl>
                        </Box>

                        <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
                          <FormControl sx={{ display: 'flex', mb: 2 }} component="fieldset">
                            <FormLabel component="legend">Guantes de Cabritilla</FormLabel>
                            <RadioGroup
                              sx={{ flex: '1', flexDirection: 'row' }}
                              aria-label="aplastamiento"
                              name="aplastamiento"
                              value={formData?.p11cabritillaGlove}
                            >
                              <FormControlLabel value="SI" control={<Radio checked={formData?.p11cabritillaGlove === 'SI'} />} label="SI" />
                              <FormControlLabel value="NO" control={<Radio checked={formData?.p11cabritillaGlove === 'NO'} />} label="NO" />
                              <FormControlLabel value="NA" control={<Radio checked={formData?.p11cabritillaGlove === 'NA'} />} label="N/A" />
                            </RadioGroup>
                          </FormControl>
                        </Box>

                        <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
                          <FormControl sx={{ display: 'flex', mb: 2 }} component="fieldset">
                            <FormLabel component="legend">Respiradores</FormLabel>
                            <RadioGroup
                              sx={{ flex: '1', flexDirection: 'row' }}
                              aria-label="golpeadorpor"
                              name="golpeadorpor"
                              value={formData?.p11breather}
                            >
                              <FormControlLabel value="SI" control={<Radio checked={formData?.p11breather === 'SI'} />} label="SI" />
                              <FormControlLabel value="NO" control={<Radio checked={formData?.p11breather === 'NO'} />} label="NO" />
                              <FormControlLabel value="NA" control={<Radio checked={formData?.p11breather === 'NA'} />} label="N/A" />
                            </RadioGroup>
                          </FormControl>
                        </Box>

                        <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
                          <FormControl sx={{ display: 'flex', mb: 2 }} component="fieldset">
                            <FormLabel component="legend">Carga manual Max. 25 Kg.</FormLabel>
                            <RadioGroup
                              sx={{ flex: '1', flexDirection: 'row' }}
                              aria-label="golpeadocon"
                              name="golpeadocon"
                              value={formData?.p11manualLoadMax25}
                            >
                              <FormControlLabel value="SI" control={<Radio checked={formData?.p11manualLoadMax25 === 'SI'} />} label="SI" />
                              <FormControlLabel value="NO" control={<Radio checked={formData?.p11manualLoadMax25 === 'NO'} />} label="NO" />
                              <FormControlLabel value="NA" control={<Radio checked={formData?.p11manualLoadMax25 === 'NA'} />} label="N/A" />
                            </RadioGroup>
                          </FormControl>
                        </Box>

                        <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
                          <FormControl sx={{ display: 'flex', mb: 2 }} component="fieldset">
                            <FormLabel component="legend">
                              Utilización de señalética especial
                            </FormLabel>
                            <RadioGroup
                              sx={{ flex: '1', flexDirection: 'row' }}
                              aria-label="caida"
                              name="caida"
                              value={formData?.p11useoFSignal}
                            >
                              <FormControlLabel value="SI" control={<Radio checked={formData?.p11useoFSignal === 'SI'} />} label="SI" />
                              <FormControlLabel value="NO" control={<Radio checked={formData?.p11useoFSignal === 'NO'} />} label="NO" />
                              <FormControlLabel value="NA" control={<Radio checked={formData?.p11useoFSignal === 'NA'} />} label="N/A" />
                            </RadioGroup>
                          </FormControl>
                        </Box>

                        <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
                          <FormControl sx={{ display: 'flex', mb: 2 }} component="fieldset">
                            <FormLabel component="legend">
                              Delimitación del área
                            </FormLabel>
                            <RadioGroup
                              sx={{ flex: '1', flexDirection: 'row' }}
                              aria-label="contactoconobjetoscortantes"
                              name="contactoconobjetoscortantes"
                              value={formData?.p11areaDelimitation}
                            >
                              <FormControlLabel value="SI" control={<Radio checked={formData?.p11areaDelimitation === 'SI'} />} label="SI" />
                              <FormControlLabel value="NO" control={<Radio checked={formData?.p11areaDelimitation === 'NO'} />} label="NO" />
                              <FormControlLabel value="NA" control={<Radio checked={formData?.p11areaDelimitation === 'NA'} />} label="N/A" />
                            </RadioGroup>
                          </FormControl>
                        </Box>

                        <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
                          <FormControl sx={{ display: 'flex', mb: 2 }} component="fieldset">
                            <FormLabel component="legend">
                              Extensiones eléctricas chequeadas
                            </FormLabel>
                            <RadioGroup
                              sx={{ flex: '1', flexDirection: 'row' }}
                              aria-label="contactoconobjetoscalientes"
                              name="contactoconobjetoscalientes"
                              value={formData?.p11electricalExtensionCheck}
                            >
                              <FormControlLabel value="SI" control={<Radio checked={formData?.p11electricalExtensionCheck === 'SI'} />} label="SI" />
                              <FormControlLabel value="NO" control={<Radio checked={formData?.p11electricalExtensionCheck === 'NO'} />} label="NO" />
                              <FormControlLabel value="NA" control={<Radio checked={formData?.p11electricalExtensionCheck === 'NA'} />} label="N/A" />
                            </RadioGroup>
                          </FormControl>
                        </Box>

                        {(formData?.p11electricalExtensionCheckImage?.length > 1 && formData?.p11electricalExtensionCheckImage !== 'none')
                          && (
                            <Card sx={{ maxWidth: 345, mt: 2, mb: 4 }}>
                              <CardMedia
                                component="img"
                                height="140"
                                image={
                                  formData?.p11electricalExtensionCheckImage
                                  && formData?.p11electricalExtensionCheckImage
                                }
                                alt="extensiones eléctricas chequeadas"
                              />
                              <CardContent>
                                <Typography gutterBottom variant="subtitle1" component="div">
                                  Extensiones eléctricas chequeadas
                                </Typography>
                              </CardContent>
                            </Card>
                          )}

                        <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
                          <FormControl sx={{ display: 'flex', mb: 2 }} component="fieldset">
                            <FormLabel component="legend">
                              Revisión de herramientas
                            </FormLabel>
                            <RadioGroup
                              sx={{ flex: '1', flexDirection: 'row' }}
                              aria-label="proyecciondeparticulas"
                              name="proyecciondeparticulas"
                              value={formData?.p11toolCheck}
                            >
                              <FormControlLabel value="SI" control={<Radio checked={formData?.p11toolCheck === 'SI'} />} label="SI" />
                              <FormControlLabel value="NO" control={<Radio checked={formData?.p11toolCheck === 'NO'} />} label="NO" />
                              <FormControlLabel value="NA" control={<Radio checked={formData?.p11toolCheck === 'NA'} />} label="N/A" />
                            </RadioGroup>
                          </FormControl>
                        </Box>
                        <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
                          <FormControl sx={{ display: 'flex', mb: 2 }} component="fieldset">
                            <FormLabel component="legend">
                              Iluminación adecuada para el trabajo
                            </FormLabel>
                            <RadioGroup
                              sx={{ flex: '1', flexDirection: 'row' }}
                              aria-label="proyecciondeparticulas"
                              name="proyecciondeparticulas"
                              value={formData?.p11lightningToWork}
                            >
                              <FormControlLabel value="SI" control={<Radio checked={formData?.p11lightningToWork === 'SI'} />} label="SI" />
                              <FormControlLabel value="NO" control={<Radio checked={formData?.p11lightningToWork === 'NO'} />} label="NO" />
                              <FormControlLabel value="NA" control={<Radio checked={formData?.p11lightningToWork === 'NA'} />} label="N/A" />
                            </RadioGroup>
                          </FormControl>
                        </Box>
                        <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
                          <FormControl sx={{ display: 'flex', mb: 2 }} component="fieldset">
                            <FormLabel component="legend">
                              Área despejada
                            </FormLabel>
                            <RadioGroup
                              sx={{ flex: '1', flexDirection: 'row' }}
                              aria-label="proyecciondeparticulas"
                              name="proyecciondeparticulas"
                              value={formData?.p11clearArea}
                            >
                              <FormControlLabel value="SI" control={<Radio checked={formData?.p11clearArea === 'SI'} />} label="SI" />
                              <FormControlLabel value="NO" control={<Radio checked={formData?.p11clearArea === 'NO'} />} label="NO" />
                              <FormControlLabel value="NA" control={<Radio checked={formData?.p11clearArea === 'NA'} />} label="N/A" />
                            </RadioGroup>
                          </FormControl>
                        </Box>
                        <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
                          <FormControl sx={{ display: 'flex', mb: 10 }} component="fieldset">
                            <FormLabel component="legend">
                              Utilización de grúas
                            </FormLabel>
                            <RadioGroup
                              sx={{ flex: '1', flexDirection: 'row' }}
                              aria-label="proyecciondeparticulas"
                              name="proyecciondeparticulas"
                              value={formData?.p11useOfGrua}
                            >
                              <FormControlLabel value="SI" control={<Radio checked={formData?.p11useOfGrua === 'SI'} />} label="SI" />
                              <FormControlLabel value="NO" control={<Radio checked={formData?.p11useOfGrua === 'NO'} />} label="NO" />
                              <FormControlLabel value="NA" control={<Radio checked={formData?.p11useOfGrua === 'NA'} />} label="N/A" />
                            </RadioGroup>
                          </FormControl>
                        </Box>
                      </Box>

                      <Grid
                        display={isAllowed ? 'flex' : 'none'}
                        justifyContent="space-evenly"
                        sx={{ mt: 4 }}
                      >
                        <Button
                          startIcon={<HighlightOffIcon />}
                          sx={{ mb: 10, bgcolor: '#db1414' }}
                          color="error"
                          variant="contained"
                          onClick={(e) => disapprove(e)}
                        >
                          Desaprobar
                        </Button>
                        <Button
                          startIcon={<CheckIcon />}
                          sx={{ mb: 10, bgcolor: '#42b50e' }}
                          color="success"
                          variant="contained"
                          onClick={(e) => approve(e)}
                        >
                          Aprobar
                        </Button>
                      </Grid>

                      <Grid sx={{ mb: 2 }} container justifyContent="space-between">
                        <Grid
                          xs={12}
                          md={5}
                          sx={{ mb: 2 }}
                        >
                          <ColorButton
                            fullWidth
                            startIcon={<ArrowLeftIcon />}
                            onClick={goToReviseStep10}
                          >
                            Ir a la página anterior
                          </ColorButton>
                        </Grid>
                        <Grid
                          xs={12}
                          md={5}
                        >
                          <ColorButton
                            fullWidth
                            endIcon={<ArrowRightIcon />}
                            onClick={goToReviseStep12}
                          >
                            Ir a la página siguiente
                          </ColorButton>
                        </Grid>

                      </Grid>
                    </>
                  )
                  : 'Por favor inicie sesión para visualizar su documento a revisar'
              }

              {user ? (
                <Typography color="green">Usted ha iniciado sesión.</Typography>
              )
                : (
                  <Typography color="red" sx={{ mt: 2 }}>Usted no ha iniciado sesión</Typography>
                )}

            </Grid>
          </Grid>
        </Slide>
      )}

    </DashboardLayout>
  )
}

export default ReviseStep11